module.exports = __webpack_public_path__ + "img/UtilityTechBackgroundC07_ua.65fb997b.webp";